let config = {}

if (window.blockCartConfig) {
  config = window.blockCartConfig
}

export const BlockCartConfig = config



// WEBPACK FOOTER //
// ./src/config/blockCartConfig.js